import React from "react";
import { inject, observer } from "mobx-react";
import classNames from "classnames";

import Language from "../../language/language";

import "../stylesheets/collectionProcess.scss";

@inject("teamStore", "languageStore", "commonStore")
@observer
export default class CollectionProcess extends React.Component {
  render() {
    return (
      <div className="processLine">
        <div className="processLine__box">
          <div className={classNames(["processLine__box--num", "processLine__box--numLeft"])}>
            <div className="processLine__box--icon">{1}</div>
          </div>
          <div className={classNames(["processLine__box--text", "processLine__box--active"])}>
            <Language resource="CONFIRM_TEAM_INFO"></Language>
          </div>
        </div>
        <div className="processLine__box">
          <div className={classNames(["processLine__box--num", "processLine__box--both"])}>
            <div className="processLine__box--icon">{2}</div>
          </div>
          <div className={classNames(["processLine__box--text", "processLine__box--noText"])}>
            <Language resource="SUBMIT_ENTRY_LIST"></Language>
          </div>
        </div>
        <div className="processLine__box">
          <div className={classNames(["processLine__box--num", "processLine__box--numRight"])}>
            <div className="processLine__box--icon">{3}</div>
          </div>
          <div className={classNames(["processLine__box--text", "processLine__box--noText"])}>
            <Language resource="SUBMIT_RESERVE_LIST"></Language>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/collectionProcess.js